import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=f4623882&scoped=true"
import script from "./MercadoPago.vue?vue&type=script&lang=js"
export * from "./MercadoPago.vue?vue&type=script&lang=js"
import style0 from "./MercadoPago.vue?vue&type=style&index=0&id=f4623882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4623882",
  null
  
)

export default component.exports